import React, {Component, createRef} from 'react'
import FJColorPanelCommon from 'fj-components/FJColorPicker';
import FJDropDown from "fj-components/FJDropDown"
import FJBGColorBtn from './FJBGColorBtn'
import './FJBGColorContainer.less';
import FJLocalStore from "../../../store/FJLocalStore";
import FJUtil from "../../../util/FJUtil";

class FJBGColorContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disabledMouseEvent: true,
        };
        this.panelCommon = createRef();
        this.dropDown = createRef();
    }

    _updateSubPanelColor = () => {
        this.panelCommon.current.updateUI({mainColor: this.props.color});
    };
    _colorDataChange = ({type, color}) => {
        if(this.props.colorDataChange) {
            this.props.colorDataChange(type, color);
        }
    };
    _disableMouseEvent = (toggle) => {
        this.setState({
            disabledMouseEvent: toggle,
        });
    };

    _toggleTooltip = (ele, bool) => {
        FJUtil.toggleTooltip(ele, bool);
    };

    render() {
        let {isDesignModule, solidColors, documentColors, addDocumentColor, deleteColor, disabled, active, color} = this.props;

        const classes = {
            panelClass: 'c-bg-color-picker-panel',
            categoryTitleClass: 'c-color-picker-title',
            addBtnClass: 'c-color-picker-add-btn',
            inputClass: 'c-color-input-box',
            inputTitleClass: 'c-color-input-title'
        };

        return (
            <FJDropDown overlay={
                <div className="c-color-popup-panel-common">
                    <FJColorPanelCommon disabled={disabled}
                                        defaultColors={solidColors}
                                        documentColors={documentColors}
                                        addDocumentColor={addDocumentColor}
                                        ref={this.panelCommon}
                                        deleteColor={deleteColor}
                                        isSolid={true}
                                        colorDataChange={this._colorDataChange}
                                        disableMouseEvent={this._disableMouseEvent}

                                        documentColorText={FJLocalStore._('document-colors')}
                                        solidColorText={FJLocalStore._('solid-colors')}
                                        doubleColorText={FJLocalStore._('double-colors')}
                                        classes={classes}
                    />
                </div>
            }
                        canTriggerActive={!isDesignModule}
                        hasArrow={false}
                        ref={this.dropDown}
                        couldEventHide={this.state.disabledMouseEvent}
                        active={active}
                        hideEvent="closeColorDropDown"
                        onShow={this._updateSubPanelColor}
                        toggleTooltip={this._toggleTooltip}
                        placement='bottomLeft'>
                <FJBGColorBtn active={active} color={color} disabled={disabled} />
            </FJDropDown>
        );
    }
}

export default FJBGColorContainer;
